/**
 * @generated SignedSource<<0348acf368acd9bd0b2e3c764cfbd1ff>>
 * @relayHash c05e048bb80b242423a40c6b393ec94c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a1aa9c420aefad4212dd0e457df6d35062707d557c801c028d4103aa3bb3afb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessCalendarQuery } from './src_jiraBusinessCalendarQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0a1aa9c420aefad4212dd0e457df6d35062707d557c801c028d4103aa3bb3afb",
    "metadata": {},
    "name": "src_jiraBusinessCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
